import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function SolutionSection() {
  const items = ['Convulsiones', 'Maniobra de desobstrucción por atragantamiento', 'Intoxicaciones y alimentos peligrosos', 'Hemorragias y heridas', 'Golpes y traumatismos', 'Emergencias respiratorias', 'Plantas tóxicas frecuentes'];
  return <section className="bg-[#F3F4F6] py-12 px-4" data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-[#111827]" data-id="element-162">
          Incluye:
        </h2>

        <div className="bg-white p-6 md:p-8 rounded-xl shadow-sm" data-id="element-163">
          <ul className="space-y-4" data-id="element-164">
            {items.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-165">
                <CheckCircle2Icon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-166" />
                <span className="text-lg text-[#4B5563] font-medium" data-id="element-167">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <p className="text-center text-xl font-bold mt-8 text-[#111827]" data-id="element-168">
          Todo explicado paso a paso.
        </p>
      </div>
    </section>;
}